import {Base} from "@/api/Base"

export class EmployeeRevokeQuit extends Base {
    path = "employee/revokeQuit"
}